import { UnixTimestamp } from '../types/unixTimestamp';
import { CustomerProductPlanType } from './CustomerProductPlanType';
import { UUID } from '../types/uuid';

export enum ELicenseMode {
  Airgap = 'airgap',
  Online = 'online',
  Offline = 'offline',
  Unused = 'unused',
  Unassigned = 'unassigned',
  Error = 'error',
}

export interface ILicense {
  name: string;
  planId: number;
  customerProductId: number;
  expiresAt: UnixTimestamp;
  suspended: boolean;
  mode: ELicenseMode;
  updatesExpiresAt: UnixTimestamp;
  planType: CustomerProductPlanType;
  isAddon: boolean;
  organizationUuid: UUID;
  offlineExpiresAt: UnixTimestamp;
  planDuration: number;
  packageId: number;
  id?: number;
  userUuid?: UUID;
  machineId?: number;
  machineName?: string;
  offlineLicensePath?: string;
  createdAt: UnixTimestamp;
  assignedAt?: UnixTimestamp;
  isDiscovery: boolean;
}
